export default __webpack_public_path__ + "static/media/Globe.e3d3a8a3.svg";